import { render, staticRenderFns } from "./CarPin.vue?vue&type=template&id=513c565d&scoped=true"
import script from "./CarPin.vue?vue&type=script&lang=ts"
export * from "./CarPin.vue?vue&type=script&lang=ts"
import style0 from "./CarPin.vue?vue&type=style&index=0&id=513c565d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c565d",
  null
  
)

export default component.exports